export const confettiCall = async (origin?: { y: number; x: number }) => {
  const confetti = await import('canvas-confetti');

  confetti.default({
    startVelocity: 75,
    particleCount: 100,
    ticks: 300,
    origin,
    zIndex: 999999999,
  });
};

export function smoothScrool(elementId: string) {
  const yOffset = -85;
  const element = document.getElementById(elementId) as HTMLElement;
  const y = element?.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({ top: y, behavior: 'smooth' });
}
